import { jsx as _jsx } from "react/jsx-runtime";
import { UniversalDialog } from 'console/dialogs/universal';
import { WeekScheduleEditor } from './week-editor';
import { memo } from 'react';
import { useInterval } from './week-view';
import { Box } from '@mui/material';
export const EditorInterval = memo(function Week() {
    const { open_editor, onClose, schedule, is_baxi_app, selectedDayId, setSelectedDayId, heating_modes, onChangeDays, selected_hc, is_boiler_zone, } = useInterval();
    return (_jsx(Box, { children: _jsx(UniversalDialog, { disable_backbutton: true, open: open_editor, onClose: onClose, title: "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F", contentWithZeroPadding: true, content_sx: {
                display: 'flex',
                flexDirection: 'column',
            }, children: _jsx(WeekScheduleEditor, { schedule: schedule, is_baxi_app: is_baxi_app, selected_day_id: selectedDayId, selectDay: setSelectedDayId, heating_modes: heating_modes, onChangeDays: onChangeDays, selected_hc: selected_hc, is_boiler_zone: is_boiler_zone }) }) }));
});
